import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { wagmiConfig } from "./lib/wallet";
import { captureReferralIntent } from "./lib/referral-intent";
import { I18nProvider } from "./i18n";
import App from "./App";
import "./index.css";

// Macro #22: capture any `?ref=<code>` as pending intent BEFORE React renders.
// Pure client intent — never canonical, never qualifies anything.
captureReferralIntent();

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </WagmiProvider>
    </I18nProvider>
  </StrictMode>,
);
